/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2024-05-03 13:45:09
 * @Description: 
 */

export const useLoging = () => {
    // 👇 收到 8888 表示：已经在其它窗口参加游戏，本窗口失去了游戏资格，将不会接收游戏指令
    const ON_DISQUALIFIED = (callback: any) => {
        socket.on(`log_off`, callback);
    };

    // 👇 收到 8889 表示：token 已经失效了（可能被删除了）需要退出当前账户 
    const ON_LOGOUT = (callback: any) => {
        socket.on(`log_out`, callback);
    };

    return {
        ON_DISQUALIFIED,
        ON_LOGOUT,
    };
};



